import axios from 'axios'
import { config } from '@/config/config'

const ax = axios.create({
  baseURL: config.apiRoot,
  timeout: 5000,
  /*headers: {
    'Accept': 'application/json',
    'Content-Type': 'text/plain'
  } */
})

const getSchedules = (requestData) => {

  const url = `/plantours/schedules`
  return ax({
    method: 'POST',
    url: url,
    data: requestData
  }).then(response => {
    return response.data
  })
}

const getCategories = (requestData) => {
  let queryString = ''

  for (let [key, value] of Object.entries(requestData)) {
    queryString += `/${value}`
  }

  const url = `/plantours/categories${queryString}`
  return ax({
    method: 'GET',
    url: url
  }).then(response => {
    return response.data
  })
}

const getDeckplan = (requestData) => {
  let queryString = ''

  for (let [key, value] of Object.entries(requestData)) {
    queryString += `${key}=${value}`
  }

  const url = `/plantours/deckplan?${queryString}`
  return ax({
    method: 'GET',
    url: url
  }).then(response => {
    return response.data
  })
}

const http = {
  getSchedules,
  getCategories,
  getDeckplan
}

export default http
